import React, { useEffect, useRef, useState } from "react";
import "./popup.css";
import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from "../constants/contact";
import { trackPhoneCallClick } from "../utils/conversionTracking";

const Popup = () => {
  const [isOpen, setIsOpen] = useState(false);
  const autoOpenTimerRef = useRef(null);
  const hasAutoOpenedRef = useRef(false);

  const closePopup = () => setIsOpen(false);

  const handleCallNow = (e) => {
    e.preventDefault();
    closePopup();
    trackPhoneCallClick({
      source: "popup-call-now-button",
      callback: () => {
        window.location.href = `tel:${SUPPORT_PHONE_TEL}`;
      },
    });
  };

  useEffect(() => {
    const openPopup = (e) => {
      e?.preventDefault();
      if (autoOpenTimerRef.current) {
        clearTimeout(autoOpenTimerRef.current);
        autoOpenTimerRef.current = null;
      }
      setIsOpen(true);
    };

    const openPopupButtons = document.querySelectorAll(".subscribe-popup-button");

    if (process.env.NODE_ENV !== "test" && !hasAutoOpenedRef.current) {
      autoOpenTimerRef.current = setTimeout(() => {
        setIsOpen(true);
        hasAutoOpenedRef.current = true;
      }, 3000);
    }

    openPopupButtons.forEach((button) => {
      button.addEventListener("click", openPopup);
    });

    return () => {
      if (autoOpenTimerRef.current) {
        clearTimeout(autoOpenTimerRef.current);
      }
      openPopupButtons.forEach((button) => {
        button.removeEventListener("click", openPopup);
      });
    };
  }, []);

  return (
    <div>
      <div
        className="popup-overlay"
        style={{ display: isOpen ? "flex" : "none" }}
        onClick={closePopup}
      >
        <div className="popup-card" onClick={(e) => e.stopPropagation()}>
          {/* Close Button */}
          <button
            type="button"
            className="popup-close-btn"
            onClick={closePopup}
            aria-label="Close popup"
          >
            ×
          </button>

          {/* Headset Icon */}
          <div className="popup-icon-wrap">
            <i className="bi bi-headset popup-headset-icon"></i>
          </div>

          {/* Title */}
          <h3 className="popup-title">Need IT Solutions Help?</h3>
          <p className="popup-desc">
            Get expert help with antivirus, printers, Windows products &amp; more.
            Call us now for immediate assistance.
          </p>

          {/* Phone Number Box */}
          <div className="popup-phone-box">
            <i className="bi bi-telephone-fill popup-phone-icon"></i>
            <a
              href={`tel:${SUPPORT_PHONE_TEL}`}
              className="popup-phone-number"
              onClick={handleCallNow}
              data-conversion-event="phone_call_click"
              data-call-source="popup-phone-number"
            >
              {SUPPORT_PHONE_DISPLAY}
            </a>
            <span className="popup-support-label">24/7 Expert Support</span>
          </div>

          {/* Feature List */}
          <ul className="popup-features">
            <li>
              <i className="bi bi-clock-fill"></i>
              Available 24/7
            </li>
            <li>
              <i className="bi bi-shield-fill-check"></i>
              Certified Experts
            </li>
            <li>
              <i className="bi bi-lightning-fill"></i>
              Quick Response Time
            </li>
          </ul>

          {/* Call Now Button */}
          <a
            href={`tel:${SUPPORT_PHONE_TEL}`}
            className="popup-call-btn"
            onClick={handleCallNow}
            data-conversion-event="phone_call_click"
            data-call-source="popup-call-now"
          >
            <i className="bi bi-telephone-fill"></i>
            CALL NOW
          </a>
        </div>
      </div>
    </div>
  );
};

export default Popup;
